// extracted by mini-css-extract-plugin
module.exports = {"block":"layout2_block__1oVFG","blockTeacher":"layout2_blockTeacher__R4Fr9","block2":"layout2_block2__T-9qu","blockMedia":"layout2_blockMedia__3Ue9W"};